var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"arrow-btn",class:{
    'curve-left': !_vm.arrowLeft,
    'curve-right': !_vm.arrowRight,
    'arrow-btn--left': _vm.arrowLeft,
    'arrow-btn--right': _vm.arrowRight,
    'router-link-exact-active': _vm.isActiveExact,
    done: _vm.done,
  },attrs:{"disabled":_vm.disabled || !_vm.to},on:{"click":_vm.goTo}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }